/* Minimal behaviour for AI replica product page sections. */
(function () {
  if (window.__aiPdp) return; window.__aiPdp = true;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: fmt }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function initProduct(root) {
    var section = root.closest('.shopify-section') || document;
    // quantity buttons
    $$('quantity-wrapper', root).forEach(function (q) {
      var input = $('input', q);
      $$('[data-quantity]', q).forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var v = parseInt(input.value, 10) || 1;
          v = a.getAttribute('data-quantity') === 'up' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    });
    // mobile slider + thumbnails
    var slider = $('[data-ai-pdp-slider] .slider', root);
    if (slider) {
      var slides = $$('.slider__item', slider);
      var thumbs = $$('.thumbnails .slider__item', root);
      var setActive = function (i) {
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      };
      slider.addEventListener('scroll', function () {
        var i = Math.round(slider.scrollLeft / Math.max(1, slider.clientWidth));
        setActive(Math.min(slides.length - 1, Math.max(0, i)));
      }, { passive: true });
      $$('[data-ai-thumb]', root).forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var i = parseInt(a.getAttribute('data-ai-thumb'), 10);
          slider.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          setActive(i);
        });
      });
      $$('[data-ai-pdp-slider] .slider-nav__btn', root).forEach(function (b) {
        b.addEventListener('click', function () {
          slider.scrollBy({ left: (b.name === 'next' ? 1 : -1) * slider.clientWidth, behavior: 'smooth' });
        });
      });
    }
    // gallery viewer
    var viewer = $('[data-ai-gallery]', section);
    if (viewer) {
      var vimg = $('[data-ai-gallery-img]', viewer);
      var close = function () { viewer.hidden = true; document.documentElement.style.overflow = ''; };
      $$('[data-ai-zoom]', root).forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var img = $('img', a);
          vimg.src = a.getAttribute('data-ai-zoom');
          vimg.alt = img ? img.alt : '';
          viewer.hidden = false; document.documentElement.style.overflow = 'hidden';
        });
      });
      viewer.addEventListener('click', function (e) { if (e.target === viewer || e.target.closest('[data-ai-gallery-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !viewer.hidden) close(); });
    }
    // variants
    var data = $('[data-ai-variants]', section);
    var variants = []; try { variants = JSON.parse(data.textContent); } catch (e) {}
    var selects = $$('[data-ai-option]', root);
    var idInput = $('[data-ai-variant-id]', root);
    var addBtn = $('.js-product-form [name="add"]', root);
    var sticky = $('[data-ai-sticky-atc]', section);
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opts = selects.map(function (s) { return s.value; });
        var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
        if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
        if (idInput) idInput.value = v.id;
        var price = $('[data-ai-price] .price', root);
        if (price) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          price.classList.toggle('price--on-sale', !!onSale);
          price.classList.toggle('price--sold-out', !v.available);
          $('.price__current', price).textContent = money(v.price);
          var was = $('.price__was', price);
          was.hidden = !onSale; was.textContent = onSale ? money(v.compare_at_price) : '';
          var callout = $('[data-ai-sale-callout]', root); if (callout) callout.hidden = !onSale;
        }
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.getAttribute('data-add-to-cart-text') : 'Sold out'; }
        if (sticky) { var sv = $('[data-ai-sticky-variant]', sticky); if (sv) sv.textContent = v.title; var sb = $('button', sticky); if (sb) sb.disabled = !v.available; }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      });
    });
    // sticky add to cart
    if (sticky) {
      var target = $('buy-buttons', root);
      sticky.classList.remove('invisible');
      var sbtn = $('[data-ai-sticky-submit]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () {
        var form = document.getElementById(sbtn.getAttribute('data-ai-sticky-submit'));
        if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
      });
      if (target && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var above = en.boundingClientRect.bottom < 0;
            sticky.classList.toggle('sticky-atc--out', en.isIntersecting || !above);
          });
        }).observe(target);
      }
    }
  }

  function initRecs(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var fresh = d.querySelector('[data-ai-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  function boot() {
    $$('[data-ai-product]').forEach(initProduct);
    $$('[data-ai-recs]').forEach(initRecs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
